// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import OpenMaintenancePlan, {getDefaultState as getOpenMaintenancePlanDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import actions from '../../../action-list';
import {getOpenMaintenancePlans} from '../../../shared/repositories';

export const readOpenMaintenancePlans = (claim, updateSelectedPlan) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getOpenMaintenancePlans(claim);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_OPEN_MAINTENANCE_PLANS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SHOW_NO_RESULTS_FOUND
            });

            const hasAMatch = data.some(plan => plan.planName === claim.planName.key);

            if (updateSelectedPlan && hasAMatch) {

                dispatch({
                    planName: claim.planName.key,
                    plans: data,
                    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SELECTED_OPEN_MAINTENANCE_PLAN
                });

            } else if (updateSelectedPlan && !hasAMatch) {

                const maintenancePlanObject = new OpenMaintenancePlan({
                    ...getOpenMaintenancePlanDefaultState(),
                    planDescription: claim.planName.value,
                    planName: claim.planName.key
                });

                dispatch({
                    maintenancePlanObject,
                    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_READ_ONLY_SELECTED_OPEN_MAINTENANCE_PLAN
                });

            }

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/get-open-maintenance-plans.js